import { useBodyStyles } from '@calendly/ui/body-styles'
import { StrictMode } from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'

import { Routes } from 'components/omniauth'

export const App = ({ store, history }) => {
  useBodyStyles()

  return (
    <StrictMode>
      <Provider store={store}>
        <Router history={history}>
          <Routes />
        </Router>
      </Provider>
    </StrictMode>
  )
}
